import each from 'lodash/each';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.us';

let cleaves = [];

function setupPhoneInputs(container) {
  const inputNodes = (container || document).querySelectorAll('input[type="tel"]');

  for (let i = 0; i < inputNodes.length; i += 1) {
    const cleave = new Cleave(inputNodes[i], {
      delimiter: '-',
      phone: true,
      phoneRegionCode: 'us',
    });

    cleaves.push(cleave);
  }
}

function teardownPhoneInputs() {
  each(cleaves, cleave => cleave.destroy());
  cleaves = [];
}

export { setupPhoneInputs, teardownPhoneInputs };
